var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect, useState } from 'react';
import { logError } from '@pegasus/sentry';
import { getBestDeals } from './request';
export function useBiggestDiscount(_a) {
    var profileFashionPreference = _a.profileFashionPreference, selectedFashionPreference = _a.selectedFashionPreference;
    var _b = useState(false), error = _b[0], setError = _b[1];
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState([]), carouselItems = _d[0], setCarouselItems = _d[1];
    useEffect(function () {
        if (!loading && !carouselItems.length) {
            setLoading(true);
            getBestDeals(__assign(__assign({}, (profileFashionPreference
                ? { profile_fashion_preference: profileFashionPreference }
                : {})), (selectedFashionPreference
                ? { selected_fashion_preference: selectedFashionPreference }
                : {})))
                .then(function (items) { return setCarouselItems((items === null || items === void 0 ? void 0 : items.configs) || []); })
                .catch(function (e) {
                setCarouselItems([]);
                setError(true);
                logError('useBiggestDiscount - Request failed', { e: e });
            })
                .finally(function () { return setLoading(false); });
        }
    }, []);
    return [carouselItems, loading, error];
}
